module.exports = __webpack_public_path__ + "static/parade-2019-house09-dbadc7a97bd724d5ba89fd3c430c7f68.jpg";